/**
 * @generated SignedSource<<baf315dd102177588e7c163c4f82813d>>
 * @relayHash e97330da43a8de21666d3b3ffc5a751e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 61bc69ec7989f4b032ea099deba62345dad209577352e046f09879c0a9efdcb2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import includeUserAccessEnabledForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access-enabled.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-d3-enabled.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "61bc69ec7989f4b032ea099deba62345dad209577352e046f09879c0a9efdcb2",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessenabledrelayprovider": includeUserAccessEnabledForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationd3enabledrelayprovider": isNumberFieldConfigurableEnabled_provider
    }
  }
};

export default node;
